import React from 'react';
import './PanelTag.scss';

export default function PanelTag (props) {
    return (
        <div className='panel-tag'>
            <label>{props.children}</label>
        </div>
    );
};